import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from "rxjs-compat";
import { AppConstant } from "src/app/app.constant";
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class UserService {
  apiUrl: string;
  kendoDataUrl: string;
  constructor(
    private httpClient: HttpClient,
    private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl()
  }

  getUsersByUserRoleIds(userRoles: number[]) {
    let params = {
      roleIds: userRoles
    }
    return this.httpClient.post(`${this.apiUrl}/userByRoleIds/`, params).pipe(
      map((response: any) => {
        return  response.data
      })
    )
  }

  getUsersByUserIds(userIds: number[]) {
    let params = {
      userIds: userIds
    }
    return this.httpClient.post(`${this.apiUrl}/userByUserIds/`, params).pipe(
      map((response: any) => {
        return  response.data
      })
    ) 
  }
  getAllUserRoles() {
    return this.httpClient.get(`${this.apiUrl}/getUserRoles/`).pipe(
      map((response: any) => {
        return response.data
      })
    )
  }
  getUserProfile() {
    return this.httpClient.get(`${this.apiUrl}/getUserProfile/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }

  getAllUsers() {
    return this.httpClient.get(`${this.apiUrl}/getAllUsers/`).pipe(
      map((response: any) => {
        return response.data
      })
    )
  }
 async getAllUserByBranch(data) {
    return (await this.httpClient.post<GridDataResult>(`${this.apiUrl}/getAllUserByBranch`,data).toPromise()).data;
  }
  async GetAllUserByBranchForFiltering(data) {
    return (await this.httpClient.post<GridDataResult>(`${this.apiUrl}/GetAllUserByBranchForFiltering`,data).toPromise()).data;
  }
}
